/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
import { InfineaModule } from '@support/infinea/infinea.module';

/** */

export const SHARED_PAYMENT = {
  MERCHANTID: 'TMOBILE',
  DECLINED: 'Declined',
  HYBRID_CARD_TYPE: 'HYBRID',
  DEBIT_CARD_TYPE: 'DEBIT',
  CREDIT_CARD_TYPE: 'CREDIT',
  HYBRID_CREDIT_CARD_TYPE: 'HYBRIDCREDIT',
  CC_MANUAL_ENTRY: 'ccodm.k3z',
  CARD_REMOVED_EARLY: 'CARD_REMOVED_EARLY',
  TECHNICAL_FALLBACK: 'TECHNICAL_FALLBACK',
  CC_SWIPE: 'swipecc.k3z',
  PIN_ENTRY_PROMPT: '1',
  INCORRECT_PIN_ENTRY_PROMPT: '15',
  AGREE: 'a',
  SIGNATURE: 'Signature',
  NO_CVM: 'No CVM',
  NEW_CREDIT_DEBIT: 'newDebit/CreditCard',
  TEMPORARYTOKEN: 'TemporaryToken',
  TRANSACTION_TIME_OUT: 'Transaction timed out',
  PIN_ENTRY_TIME_OUT: 'Time Out',
  IPC_PIN_ENTRY_TIME_OUT: 'Transaction canceled pin entry timeout',
  CARD_INSERT_TIME_OUT: 'card Insert timed out',
  PIN_ENTRY_LIMIT_EXCEEDED: 'pin entry limit exceeded',
  ZERO: '0',
  VALID: 'VALID',
  SUPPORTED: 'Supported',
  REJECT: 'reject',
  ACCEPT: 'accept',
  APPROVAL: 'approval',
  DECLINE: 'decline',
  VOID_PROCESSED: 'void_processed',
  CREATED: 'created',
  PART_AUTH: 'PART_AUTH',
  CASH: 'Cash',
  CARD: 'Card',
  REMOVE_SPLITCARD: 'RemoveSplitcard',
  UPDATE: 'Update',
  REMOVE: 'REMOVE',
  CART_PAYMENT_SCREEN: 'PaymentScreen',
  CART_COLLECTED: 'CASH_COLLECTED',
  VALIDATED: 'validated',
  CASH_COLLECTED: 'cash_collected',
  NEW: 'new',
  INVALID_BARCODE: 'invalid barcode',
  CDM_REVIEW: 'cdm_review',
  REVIEW: 'review',
  MAX_INCORRECT_PIN_COUNT: 3,
  DEFAULT_YEAR_CENTURY: '20',
  CART_REVIEW: '/cart/review',
  ORDER_CONFIRMATION: '/order-confirmation',
  HYBRID: 'Hybrid',
  USD: 'USD',
  PERMANENTTOKEN: 'PermanentToken',
  JPAY: 'jpay',
  PAYMENT: 'PAYMENT',
  S: 'S',
  ADD_SUBMIT: 'ADD_SUBMIT',
  CURRENCY: 'USD',
  SUBMIT: 'SUBMIT',
  SIGNATURE_UPDATE: 'SIGNATURE_UPDATE',
  ADD: 'ADD',
  REFUND: 'REFUND',
  BLOCKED: 'BLOCKED',
  CHECKED: 'checked',
  TEST_NAME: 'Test',
  BIN_LAST_CHAR: 6,
  LAST_FOUR_CHAR: 4,
  TIME_OUT: 'TIME_OUT',
  MAX_IDLE_TIME: 120000,
  NEW_CREDIT_DEBIT_CARD: 'newCreditDebitCard',
  RETURN: 'RETURN',
  EXCHANGE: 'EXCHANGE',
  MAX_COUNT: 3,
  MIN_LIMIT: '0.01',
  MAX_LIMIT: '5000',
  SLICE_ZERO: 0,
  PROCESSING_PLEASE_WAIT: 'Processing... please wait',
  CART: '/cart',
  BACK_ORDER: 'BACKORDER',
  PREPAID: 'Prepaid',
  ACCESSORY: 'Accessory',
  ACTIVE: 'ACTIVE',
  MSR_TERMINAL_ENTRY_MODE: '90',
  EMV_TERMINAL_ENTRY_MODE: '05',
  FALLBACK_TERMINAL_ENTRY_MODE: '80',
  CARD_INSERTED: 'CARD_INSERTED',
  CARD_REMOVED: 'CARD_REMOVED',
  MSR_CONTACT_LIST_ENTRY_MODE: '91',
  MAX_AMOUNT: 200,
  HARD_GOODS: 'HardGoods',
  SOFT_GOODS: 'SoftGoods',
  DEBIT: 'Debit',
  CREDIT: 'Credit',
  FINANCIAL_TRANSACTION_TYPE: 'Sale',
  PAYMENT_PROGRAM_CODE: 'U2PRECP',
  ONLINE_OFFLINE_CODE: 'O',
  CARD_READ_FAILED: 'Card read failed',
  BLOCKED_CARD_BLOCKED_AID: 'Card read failed, Card Blocked',
  TRANSACTION_CANCELLED: 'Transaction cancelled by user',
  CARD_DECLINED: 'Card declined',
  CARD_UNREADABLE: 'CardUnreadable',
  CREDIT_DEBIT_PAYMENT_OPTION: 'debitCredit',
  PIN_ERROR_DEBIT: 'PIN_ERROR_DEBIT',
  INFINEA_MODULE: 'InfineaModule',
  INVALID_CARD: 'Invalid card',
  FRAUD_REVIEW: 'REVIEW',
  pleaseCorrectError: 'Please correct the errors below.',
  MANUAL_IMPRINT: 'manualImprint',
  TERMINAL_ENTRY_MANUAL_IMPRINT: '01',
  MAX_PIN_ATTEMPTS: 'Too many PIN entry attempts',
  INVALID_PIN: 'Invalid PIN. Payment Cancelled.',
  CREDIT_PAYMENT: 'credit',
  MANUALIMPRINT: 'MANUAL_IMPRINT',
  CANCEL: 'cancel',
  APPROVE_OVERRIDE: 'approve_override',
  CONFIRM: 'confirm',
  SECONDARY_BUTTON: 'btn btn-secondary',
  PRIMARY_BUTTON: 'btn btn-primary',
  DISC_CHECK: 'DISC',
  USB_CASH_DRAWER_ERROR: 'error',
  USB_CASH_DRAWER_NOT_FOUND: 'notfound',
  AMOUNT_VAL: '0.00',
  PROGRAM_CODE_CNP: 'U2PRECNP',
  PAN: 'PAN',
  SIX: 6,
  ANON: 'ANON',
};

export const CARD_TYPE = {
  DISC: 'DISCOVER',
  DISCOVER: 'DISCOVER',
  AMEX: 'AMERICANEXPRESS',
  VISA: 'VISA',
  MSCD: 'MASTERCARD',
  MASTERCARD: 'MASTERCARD',
  DEBIT: '',
};

export const IPC_MESSAGE_KEY = {
  pleaseSwipeTapToPay: 'pleaseSwipeTapToPay',
  pleaseInsertSwipeTapToPay: 'pleaseInsertSwipeTapToPay',
  pleaseWaitDoNotRemove: 'pleaseWaitDoNotRemove',
  processingPleaseWait: 'processingPleaseWait',
  pleaseRemoveCard: 'pleaseRemoveCard',
  timeOutRemoveCard: 'timeOutRemoveCard',
  timeOutTransactionCancelled: 'timeOutTransactionCancelled',
  reEntryPin: 'reEntryPin',
  entryPin: 'entryPin',
  debitPrompt: 'debitPrompt',
  creditPrompt: 'creditPrompt',
  authorize: 'authorize',
  cancelPrompt: 'cancelPrompt',
  transactionCancelledRemoveCard: 'transactionCancelledRemoveCard',
  transactionCancelled: 'transactionCancelled',
  cardDeclinedRemoveCard: 'cardDeclinedRemoveCard',
  cardDeclined: 'cardDeclined',
  cardReadError: 'cardReadError',
  pleaseSwipeToPay: 'pleaseSwipeToPay',
  authorizing: 'Authorizing...',
  amount: 'Amount $',
  swipeOrTapCard: 'Swipe or tap card',
};

export const IPC_MESSAGE = {
  pleaseSwipeTapToPay: 'Please Swipe or Tap your card',
  pleaseInsertSwipeTapToPay: 'Please Insert, Swipe or Tap to pay',
  pleaseWaitDoNotRemove: 'Please wait... Do not remove card',
  processingPleaseWait: 'Processing... please wait',
  pleaseRemoveCard: 'Please remove card',
  timeOutRemoveCard: 'Payment cancelled due to timeout. Please remove card.',
  timeOutTransactionCancelled: 'Transaction cancelled due to timeout.',
  entryPin: 'Please enter PIN to authorize $',
  reEntryPin: 'Invalid PIN. Please reenter PIN to authorize $',
  transactionCancelledRemoveCard: 'Transaction cancelled. Please remove card.',
  cardDeclinedRemoveCard: 'Unable to process the card. Please remove card.',
  cardDeclined: 'Unable to process the card.',
  transactionCancelled: 'Transaction cancelled.',
  authorize: 'Authorize: $',
  debitPrompt: '\nPress OK for Debit',
  creditPrompt: '\nPress C for Credit',
  cancelPrompt: '\nPress C for Cancel',
  cardReadError: 'Card read error',
  pleaseSwipeToPay: 'Please ask customer to swipe the card',
};

export const NAVIGATION_DATA = {
  FIRST_PAYMENT_METHOD_SET: 'firstPaymentMethodSet',
  REMOVE_PAYMENT_METHOD: 'removePaymentMethod',
  REMOVE_PAYMENT_METHOD_SUCCESS: 'removePaymentMethodSuccess',
  REMOVE_PAYMENT_API_ERROR: 'removePaymentAPIError',
  ENABLE_ROUTE: 'enableRoute',
  ENABLE_BACK_NAV_BUTTON: 'enableBackNavButton',
  DISABLE_BACK_NAV_BUTTON: 'disableBackNavButton',
};
